module.exports = __webpack_public_path__ + "static/media/Link.79c33b5c.jpg";